<template>
    <div class="page">
      <div class="padding10">
        <el-tabs>
          <el-tab-pane label="基本设置">
            <el-form size="small" label-width="100px" class="margin15-tb">
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="姓名：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.customerName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="性别：">
                    <el-select placeholder="请选择" v-model="simulateInfoAddReq.gender" style="width:100%">
                      <el-option
                        v-for="item in sexSelectOption"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="年龄：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.age"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="身份证号：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.idNo"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="手机号：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.phone"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="贷款机构：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.loanInstitutions"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="借款产品名称：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.loanProductName"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="联系人姓名：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.relationName"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="联系人名单：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.relationRoll"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="padding10">
        <el-tabs>
          <el-tab-pane label="金额参数">
            <el-form size="small" label-width="100px" class="margin15-tb">
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="签约金额：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.signedAmount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="放款金额：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.loanAmount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="月还款额：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.monthlyRepay"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="剩余本金：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.residualPrincipal"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="罚滞总额：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.totalPenalty"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="逾期总额：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.overdueAmount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="最后一次还款金额：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.lastRepayAmount"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="委托金额：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.delegateAmount"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="padding10">
        <el-tabs>
          <el-tab-pane label="时间参数">
            <el-form size="small" label-width="100px" class="margin15-tb">
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="放款日期：">
                    <el-date-picker style="width: 100%;"
                                    v-model="simulateInfoAddReq.dateOfLoan"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期时间">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="借款期数：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.loanPeriod"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="逾期次数：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.overdueTime"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="最后一次还款时间：">
                    <el-date-picker style="width: 100%;"
                                    v-model="simulateInfoAddReq.lastRepayDate"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期时间">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="借款日期：">
                    <el-date-picker style="width: 100%;"
                                    v-model="simulateInfoAddReq.dateOfBorrow"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="选择日期时间">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="逾期天数：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.overdueDates"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="已还期数：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.repayedPeriods"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="账单日：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.statementDate"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="padding10">
        <el-tabs>
          <el-tab-pane label="还款信息">
            <el-form size="small" label-width="100px" class="margin15-tb">
              <el-row :gutter="24">
                <el-col :span="6">
                  <el-form-item label="开户人：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.bankPeople"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="银行卡号：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.cardNumber"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="还款银行：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.bank"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="联系电话：">
                    <el-input placeholder="请输入" v-model="simulateInfoAddReq.companyContact"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer" class="text right">
        <el-button type="primary" size="small" @click="saveCollectionInfo" plain>保存</el-button>
      </div>
    </div>
</template>
<script>

export default {
  data() {
    return {
      simulateInfoAddReq: {
        customerName: '张三',
        gender: '男',
        age: '30',
        idNo: '110004199002274567',
        phone: '13888888899',
        loanInstitutions: '钱站APP',
        loanProductName: '宜人贷',
        relationName: '李明',
        relationRoll: '李明,王大,赵四',
        signedAmount: '24000.0',
        loanAmount: '20000.0',
        monthlyRepay: '2000.0',
        residualPrincipal: '13000.0',
        totalPenalty: '500.0',
        overdueAmount: '6000.0',
        lastRepayAmount: '2000.0',
        delegateAmount: '6000.0',
        dateOfLoan: '2026-01-01 17:17:00',
        dateOfBorrow: '2026-01-01 17:17:00',
        loanPeriod: '23',
        overdueTime: '123',
        lastRepayDate: '2026-02-01 17:17:00',
        overdueDates: '2',
        repayedPeriods: '1',
        statementDate: '7',
        bankPeople: '李四1',
        cardNumber: '6445123447521234',
        bank: '招商银行',
        companyContact: '13512341243'
      },
      sexSelectOption: [
        {
          value: '男',
          label: '男'
        },
        {
          value: '女',
          label: '女'
        }
      ]
    };
  },
  mounted() {
    this.getSimulateInfo();
  },
  methods: {
    getSimulateInfo() {
      this.$ajax({
        url: '/simulate/gotoRobotSimulate',
        method: 'get'
      }).then((res) => {
        if (res.data !== null) {
          this.simulateInfoAddReq = res.data;
        }
      });
    },
    saveCollectionInfo() {
      this.$ajax({
        url: '/simulate/saveBaseInfo',
        data: this.simulateInfoAddReq,
        prompt: true
      }).then(
        this.getSimulateInfo()
      );
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/test_engine/collection_information.vue